import React from 'react';

const EmailNotificationFields = ({ formData, onChange, errors = {}, embedded = false }) => {
  if (!formData?.can_access?.email_notification) {
    return null;
  }

  const em = formData.email_notification_settings || {};

  const handleEmChange = (e) => {
    const { name, value, type, checked } = e.target;
    let nextValue = value;
    if (type === 'checkbox') {
      nextValue = checked;
    } else if (name === 'mail_port') {
      nextValue = value === '' ? '' : Number(value);
    }

    onChange({
      target: {
        name: 'email_notification_settings',
        value: {
          mail_server: em.mail_server || 'smtp.gmail.com',
          mail_port: em.mail_port ?? 587,
          mail_use_tls: em.mail_use_tls !== false,
          mail_use_ssl: Boolean(em.mail_use_ssl),
          mail_username: em.mail_username || '',
          mail_password: em.mail_password || '',
          mail_default_sender: em.mail_default_sender || '',
          ...em,
          [name]: nextValue,
        },
      },
    });
  };

  return (
    <div>
      {!embedded && (
        <h3 className="text-base sm:text-md font-semibold text-gray-700 mb-3 sm:mb-4 pb-2 border-b-2 border-grey-400">
          Email Notification (SMTP)
        </h3>
      )}
      <p className="text-xs sm:text-sm text-gray-500 mb-3">
        Used for company outbound emails (shipment, invoice, salary, daily summary).
        Emails are sent only when Email Notification is enabled and SMTP credentials are saved.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-6">
        <div>
          <label className="block text-xs sm:text-sm font-medium text-secondary mb-1 sm:mb-2">
            Mail Server
          </label>
          <input
            type="text"
            name="mail_server"
            value={em.mail_server || ''}
            onChange={handleEmChange}
            placeholder="smtp.gmail.com"
            className={`w-full px-3 sm:px-4 py-2 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base ${
              errors.mail_server ? 'border-red-400' : 'border-gray-300'
            }`}
            autoComplete="off"
          />
        </div>
        <div>
          <label className="block text-xs sm:text-sm font-medium text-secondary mb-1 sm:mb-2">
            Mail Port
          </label>
          <input
            type="number"
            name="mail_port"
            value={em.mail_port ?? 587}
            onChange={handleEmChange}
            placeholder="587"
            className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base"
          />
        </div>
        <div>
          <label className="block text-xs sm:text-sm font-medium text-secondary mb-1 sm:mb-2">
            Default Sender
          </label>
          <input
            type="email"
            name="mail_default_sender"
            value={em.mail_default_sender || ''}
            onChange={handleEmChange}
            placeholder="noreply@company.com"
            className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base"
            autoComplete="off"
          />
        </div>
        <div>
          <label className="block text-xs sm:text-sm font-medium text-secondary mb-1 sm:mb-2">
            Mail Username
          </label>
          <input
            type="text"
            name="mail_username"
            value={em.mail_username || ''}
            onChange={handleEmChange}
            placeholder="company@gmail.com"
            className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base"
            autoComplete="off"
          />
        </div>
        <div>
          <label className="block text-xs sm:text-sm font-medium text-secondary mb-1 sm:mb-2">
            Mail Password
          </label>
          <input
            type="password"
            name="mail_password"
            value={em.mail_password || ''}
            onChange={handleEmChange}
            placeholder={em.has_mail_password ? '•••••••• (leave blank to keep)' : 'App password / SMTP password'}
            className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base"
            autoComplete="new-password"
          />
        </div>
        <div className="flex flex-col justify-end gap-3 pb-1">
          <label className="inline-flex items-center gap-2 text-xs sm:text-sm text-gray-800">
            <input
              type="checkbox"
              name="mail_use_tls"
              checked={em.mail_use_tls !== false}
              onChange={handleEmChange}
              className="w-4 h-4 text-orange-600 focus:ring-blue-400 border-gray-300 rounded"
            />
            Use TLS (STARTTLS)
          </label>
          <label className="inline-flex items-center gap-2 text-xs sm:text-sm text-gray-800">
            <input
              type="checkbox"
              name="mail_use_ssl"
              checked={Boolean(em.mail_use_ssl)}
              onChange={handleEmChange}
              className="w-4 h-4 text-orange-600 focus:ring-blue-400 border-gray-300 rounded"
            />
            Use SSL
          </label>
        </div>
      </div>
    </div>
  );
};

export default EmailNotificationFields;
